import React, { useMemo } from "react";
import { ReactComponent as SolidJersey } from "../../assets/kits/soccer-jersey-0.svg";
import { ReactComponent as DiagonalTripleBandsJersey } from "../../assets/kits/soccer-jersey-1.svg";
import { ReactComponent as HorizontalHoopsJersey } from "../../assets/kits/soccer-jersey-2.svg";
import { ReactComponent as HorizontalBands4Jersey } from "../../assets/kits/soccer-jersey-3.svg";
import { ReactComponent as VerticalBlocks4Jersey } from "../../assets/kits/soccer-jersey-4.svg";
import { ReactComponent as QuarteredJersey } from "../../assets/kits/soccer-jersey-5.svg";
import { ReactComponent as VerticalStripesWideJersey } from "../../assets/kits/soccer-jersey-6.svg";
import { ReactComponent as CrossJersey } from "../../assets/kits/soccer-jersey-7.svg";
import { ReactComponent as PinstripesDenseJersey } from "../../assets/kits/soccer-jersey-8.svg";
import { ReactComponent as TriptychPanelsJersey } from "../../assets/kits/soccer-jersey-9.svg";
import { ReactComponent as GenericVerticalsJersey } from "../../assets/kits/soccer-jersey-10.svg";

export type Kit = {
  id: number;
  si?: string | null;
  so?: string | null;
};

const Registry: Record<number, React.FC<React.SVGProps<SVGSVGElement>>> = {
  10: SolidJersey,
  1: DiagonalTripleBandsJersey,
  2: HorizontalHoopsJersey,
  3: HorizontalBands4Jersey,
  4: VerticalBlocks4Jersey,
  5: QuarteredJersey,
  15: VerticalStripesWideJersey,
  7: CrossJersey,
  8: PinstripesDenseJersey,
  9: TriptychPanelsJersey,
  0: GenericVerticalsJersey,
};

export function Shirt({
  color,
  kit,
  widthVw,
  width,
  height,
  className,
}: {
  color?: string;
  kit?: Kit | null;
  widthVw?: number;
  width?: string | number;
  height?: string | number;
  className?: string;
}) {
  const baseStyle: React.CSSProperties = {};
  if (width != null)
    baseStyle.width = typeof width === "number" ? `${width}px` : width;
  if (height != null)
    baseStyle.height = typeof height === "number" ? `${height}px` : height;
  if (!width && !height && widthVw)
    baseStyle.width = baseStyle.height = `${widthVw}vw`;
  if (!width && !height && !widthVw) {
    baseStyle.width = baseStyle.height = "6vw";
  }

  const colors = useMemo(() => {
    const arr = (kit?.si || "")
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean);
    if (arr.length === 0 && color) return [color];
    if (arr.length === 0) return ["#999"];
    return arr;
  }, [kit?.si, color]);

  const cssVars = useMemo(() => {
    const vars: Record<string, string> = {};
    const base = colors.length ? colors : ["#999"];
    const MAX = 12;
    for (let i = 0; i < MAX; i++) {
      vars[`--c${i + 1}`] = base[i] ?? base[0];
    }
    return vars;
  }, [colors]);

  const kitId = kit?.id ?? 0;

  const PatternComp = Registry[kitId] || SolidJersey;

  return (
    <div
      className={[
        "grid aspect-square place-items-center drop-shadow-[0_6px_20px_rgba(0,0,0,0.35)]",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ color: colors[0], ...baseStyle }}
      aria-hidden
    >
      <PatternComp style={{ ...cssVars, width: "100%", height: "100%" }} />
    </div>
  );
}
